import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableContainer, Table, Thead, Tbody, Tr, Td, LineContent, CustomLink } from './styles';

const ProductsTableSkeleton = ({ device, isTableOpen }) => {
  const { t } = useTranslation();
  const headers = [
    `Tipo de ${t('panel.available.products.plan')}`,
    'panel.available.products.plan',
    'panel.available.products.availables',
    'panel.available.products.active'
  ];
  return (
    <>
      {device !== 'mobile' && isTableOpen && (
        <TableContainer>
          <Table>
            <Thead>
              <Tr height='54px'>
                {headers.map(item => {
                  return (
                    <Td key={item} data-panel={item}>
                      {t(item)}
                    </Td>
                  );
                })}
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>
                  <LineContent width='114px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='168px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='46px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='46px' height='19px' />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <LineContent width='118px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='130px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='46px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='46px' height='19px' />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <LineContent width='93px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='138px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='46px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='46px' height='19px' />
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

ProductsTableSkeleton.propTypes = {
  device: PropTypes.string.isRequired
};

export default ProductsTableSkeleton;
